import type { ValueOf } from '@weft/utils';

export const PLAN_CREATION_REASONS = Object.freeze({
  NewPlan: 'NewPlan',
  EditContract: 'EditContract',
  ReviseCurrentContract: 'ReviseCurrentContract',
  ReviseContractForRenewal: 'ReviseContractForRenewal',
});

export type PlanCreateReason = ValueOf<typeof PLAN_CREATION_REASONS>;